import { Code2, Layers3, MonitorPlay, ShieldCheck } from "lucide-react";
import mainLogin from "../../assets/images/main-bg.png";
import ResponsiveImage from "../common/ResponsiveImage";

const SectionBanner = () => {
  return (
    <div className="relative w-full ovearflow-hidden">
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="floating-shape shape-1"></div>
        <div className="floating-shape shape-2"></div>
        <div className="floating-shape shape-3"></div>
      </div>

      <div className="container mx-auto flex min-h-[400px] flex-col items-center justify-center overflow-hidden px-4 py-8 sm:px-6 md:flex-row md:px-[40px] lg:h-[500px] lg:py-0">
        <div className="order-2 mb-8 mt-5 w-full pb-0 text-left sm:mt-0 md:mt-0 md:p-0 md:pb-10 md:pt-20 lg:order-1 lg:mb-0 lg:w-1/2">
          <span className="inline-flex items-center rounded-full border border-red-500/20 bg-red-50 px-4 py-2 text-[11px] font-medium uppercase tracking-[0.16em] text-red-700">
            Giải pháp toàn diện
          </span>

          <h1 className="mt-5 max-w-[680px] text-[27px] font-medium leading-[1.16] color-second mobile523:text-[29px] mobile598:text-[33px] md:text-[27px] mdconfig:text-[31px] lg:text-[36px] lgconfig:text-[41px] xlconfig:text-[45px]">
            Hệ Sinh Thái Giải Pháp Số Toàn Diện Cho Doanh Nghiệp
          </h1>

          <p className="mt-5 max-w-[640px] text-[14px] leading-8 text-gray-600 mobile598:text-[15px] md:text-[13px] lg:text-[15px] lgconfig:text-[16px] xlconfig:text-[17px]">
            Từ xây dựng nền tảng công nghệ, tối ưu vận hành đến bứt phá doanh thu. TrioCore Solutions
            đồng hành cùng bạn số hóa quy trình kinh doanh một cách thực tế và hiệu quả bền vững.
          </p>

          <div className="mt-6 flex flex-col justify-start gap-3 sm:flex-row sm:gap-4 md:mt-8 lg:mt-8 md:justify-start">
            <button className="button-secondary w-full sm:w-auto">
              <svg className="h-5 w-5 text-[var(--textBlue58)]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
                />
              </svg>
              Nhận tư vấn giải pháp
            </button>

            <button className="button-primary w-full sm:w-auto">
              <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
                />
              </svg>
              Khám phá dịch vụ
            </button>
          </div>
        </div>

        <div className="order-1 w-full lg:w-1/2 md:order-2">
          <div className="welcome-meter">
            <div className="home-profile-area relative flex h-[240px] items-center justify-center overflow-visible mobile598:h-[280px] sm:h-[330px] md:h-[380px] lg:h-[500px]">
              <div className="home-inner-circle">
                <ResponsiveImage className="home-hero-art" src={mainLogin} alt="Digital business solutions illustration" fetchPriority="high" loading="eager" />
              </div>

              <div className="home-orbit-layer" aria-hidden="true">
                <div className="home-outer-circle" />
                <div className="home-orbit-track">
                  <div className="home-orbit-badge home-orbit-badge-1">
                    <span className="home-orbit-badge-inner">
                      <MonitorPlay size={16} />
                    </span>
                  </div>
                  <div className="home-orbit-badge home-orbit-badge-2">
                    <span className="home-orbit-badge-inner">
                      <Code2 size={16} />
                    </span>
                  </div>
                  <div className="home-orbit-badge home-orbit-badge-3">
                    <span className="home-orbit-badge-inner">
                      <ShieldCheck size={16} />
                    </span>
                  </div>
                  <div className="home-orbit-badge home-orbit-badge-4">
                    <span className="home-orbit-badge-inner">
                      <Layers3 size={16} />
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SectionBanner;
